import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faSignOutAlt,

}
  from "@fortawesome/free-solid-svg-icons";
import Login from "../../pages/login/Login";

import HomeSearch from "../../pages/homesearch/HomeSearch";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAdvertisement, setModal, setTokenAction } from "../../redux/slice/Slice";
import toast from "react-hot-toast";
import Popup from "../../common/popup/Popup";
import Api_Instance from "../../api/Api_Instance";
import { BASE_URL } from "../../api/endpoints";
import { IoSearch } from "react-icons/io5";
import Category from "../dropdown/Category";
import { useTranslation } from "react-i18next";
import { HiMenuAlt2 } from "react-icons/hi";
import UserScreenSize from "../../common/useScreenSize/UserScreenSize";
import Register from "../../pages/register/Register";
import { RxDashboard } from "react-icons/rx";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoMdCloseCircleOutline } from "react-icons/io";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";



function Header() {
  const api = Api_Instance.unAuth()
  const dispatch = useDispatch();
  const { width } = UserScreenSize();
  const { i18n } = useTranslation();
  const location = useLocation()
  const token = useSelector((state) => state.auth.token);
  const openpopup = useSelector((state) => state.auth.modal);
  const loader = useSelector((state) => state?.auth?.loader)
  const tokenexpired = useSelector((state) => state?.auth?.login)
  const advertisementData = useSelector((state) => state?.auth?.advertisement_data)
  const [showLogin, setShowLogin] = useState(false);
  const [register, setRegister] = useState(false)
  const [isSearch, setIsSearch] = useState(false);
  const [ismobilemenu, setMobileMenu] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [show, setShow] = useState(false)
  const headerRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    setIsModalOpen(openpopup)
  }, [openpopup])
  const openModal = () => {
    setIsModalOpen(true);
    dispatch(setModal(true))
  };

  const closeModal = () => {
    dispatch(setModal(false))
    setIsModalOpen(false);
  };
  useEffect(() => {
    setShowLogin(tokenexpired)
  }, [tokenexpired])

  const closeLoginForm = () => {
    setShowLogin(false);

  };
  const onCloseRegister = () => {
    setRegister(false);

  };
  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  const handleLogout = () => {
    closeLoginForm()
    handleClickOutside()
    dispatch(setTokenAction(null));
    toast.success("Logged out successfully");
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event?.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);
  const modalRef = useRef(null);

  const handleClickOutsideCategory = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setShow(false);
    }
  };

  useEffect(() => {
    if (show) {
      document.addEventListener("mousedown", handleClickOutsideCategory);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideCategory);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideCategory);
    };
  }, [show]);
  const advertise_data = async () => {
    try {
      const res = await api("GET", `${BASE_URL}/accounts/Advertising/?date`)
      dispatch(setAdvertisement(res?.data?.data))
    } catch (error) {

    }

  }
  useEffect(() => {
    advertise_data()
  }, [])

  console.log(width, 'width')

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        const sticky = headerRef.current.offsetTop;
        if (window.pageYOffset > sticky) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const UserDropdown = ({ handleLogout }) => {
    return (
      <div
        className="absolute top-full right-0 mt-2 w-48 bg-white border border-gray-200 rounded shadow-md"
        ref={dropdownRef}
      >
        <ul>
          {/* <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">Prashant</li> */}
          <li
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
            onClick={handleLogout}
          >
            <div className=" flex items-center gap-2 cursor-pointer">
              <FontAwesomeIcon
                icon={faSignOutAlt}
                className="text-[#777777]"
                size="1x"
              />
              <p className="mr-2 text-[#777777]">Logout</p>

            </div>
          </li>
        </ul>
      </div>
    );
  };

  //mobile view slider
  const mainCarouselItems = advertisementData
    ?.filter((item) => item?.category === "banner1" || item?.category === "banner2" || item?.category === "banner3")
    .map((item, index) => (
    
       
        <div key={index}
            className="p-1 border cursor-pointer w-[100%] md:w-[210px] xl:w-[310px]"
        >
          <a
            href={item?.url}
            target="_blank"
            rel="noopener noreferrer"
             className="block max-w-[100%]"
          >
            <img
              className="w-full h-[35px] xl:h-[50px]"
              src={item?.image}
              alt={`Ad ${index + 1}`}
            />
          </a>
        </div>
    
    ));

  return (
    <>
      {/* First Navbar */}

      <div className="bg-[#F0F0F0] py-[8px] hidden md:block">
        <div className="w-full max-w-[1250px] mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
          <div className="flex justify-center w-full mx-auto items-center ">
            <div className="d-block">
              <div className="hidden md:flex flex-wrap justify-start items-center xl:gap-1 lg:gap-1 gap-0">
                <NavLink
                  className="nav-link text-sm text-[#777777]"
                  aria-current="page"
                  to="/buysell"
                  onClick={closeModal}
                >
                  Buy/Sell Existing Business
                </NavLink>
                <span className="mx-[10px] text-[#777777]">|</span>
                <NavLink className="nav-link text-sm text-[#777777]" to="/franchiser">
                  Expand Your Business
                </NavLink>
                <span className="mx-[10px] text-[#777777]">|</span>
                <NavLink className="nav-link text-sm text-[#777777]" to="/advertise" onClick={closeModal}>
                  Advertise
                </NavLink>
                <span className="mx-[10px] text-[#777777]">|</span>
                <NavLink className="nav-link text-sm text-[#777777]" to="/raisefund" onClick={closeModal}>
                  Raise Fund
                </NavLink>
                <span className="mx-[10px] text-[#777777]">|</span>
                <NavLink
                  className="nav-link text-sm text-[#777777]"
                  aria-disabled="true"
                  to="/loan-bussiness"
                  onClick={closeModal}
                >
                  Loan For Business
                </NavLink>
              </div>
            </div>
            <div className="flex items-center gap-2">
              {/* <SiGoogletranslate className="cursor-pointer text-[24px]" /> */}
              {/* <select
                    onChange={handleLanguageChange}
                    className="border-none bg-transparent text-white focus:outline-none w-[85px]"
                  >
                    <option value="hi" className="text-black">Hindi</option>
                    <option value="en" className="text-black">English</option>
                  </select> */}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#ffffff]">
        <div className="max-w-[1250px] mx-auto flex items-center justify-between py-2 xl:py-3 px-3 sm:px-5">
        <div className="w-[40%] lg:w-[auto]">
            <Link to="/" className="cursor-pointer">
              <img className="max-w-[140px] w-full lg:max-w-[200px] sm:max-w-[160px]" src="../img/FranchiseBX logo.png" alt="img" />
            </Link>
          </div>
          
          {width <= 1024 ?
            <div className="pl-5 w-[60%] lg:w-[auto]">
            <AliceCarousel
              items={mainCarouselItems}
              autoPlay
              infinite
              autoPlayInterval={1500}
              disableDotsControls
              disableButtonsControls
              responsive={{
                320: { items: 1 },
   
              }}
             
            />
           </div>
            : 

              <div className="flex items-center flex-wrap justify-self-end gap-[10px] xl:justify-between">
                {advertisementData?.map((item, index) => {
                  if (

                    item?.category === "banner1"
                  ) {
                    return (
                      <div
                        key={index}
                        className="p-1 border cursor-pointer w-[100%] md:w-[210px] xl:w-[310px]"
                      >
                        <a
                          href={item?.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block max-w-[100%]"
                        >
                          <img
                              className="w-full h-[35px] xl:h-[50px]"
                            src={item?.image}
                            alt={`Ad ${index + 1}`}
                          />
                        </a>
                      </div>
                    );
                  }
                  return null;
                })}
                {advertisementData?.map((item, index) => {
                  if (
                    item?.category === "banner2"
                  ) {
                    return (
                      <div
                        key={index}
                         className="p-1 border cursor-pointer w-[100%] md:w-[210px] xl:w-[310px]"
                      >
                        <a
                          href={item?.url}
                          target="_blank"
                          rel="noopener noreferrer"
                            className="block max-w-[100%]"
                        >
                          <img
                        className="w-full h-[35px] xl:h-[50px]"
                            src={item?.image}
                            alt={`Ad ${index + 1}`}
                          />
                        </a>
                      </div>
                    );
                  }
                  return null;
                })}
                {advertisementData?.map((item, index) => {
                  if (
                    item?.category === "banner3"
                  ) {
                    return (
                      <div
                        key={index}
                        className="p-1 border cursor-pointer w-[100%] md:w-[210px] xl:w-[310px]"
                      >
                        <a
                          href={item?.url}
                          target="_blank"
                          rel="noopener noreferrer"
                           className="block max-w-[100%]"
                        >
                          <img
                            className="w-full h-[35px] xl:h-[50px]"
                            src={item?.image}
                            alt={`Ad ${index + 1}`}
                          />
                        </a>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>

           }
        </div>
      </div>
      <div ref={headerRef}
        className={`bg-[#13A9D3] headerbox ${isSticky ? "sticky top-0 z-[1000]" : ""}`}
        id="myHeader"
      >
        <div className="flex items-center py-[10px] w-full max-w-[1250px] relative mx-auto flex-row-reverse xl:px-0 lg:px-0 md:px-5 px-4 sm:justify-between lg:!flex-row">
          <div className=" relative text-[16px] font-medium" onClick={() => setShow(prev => !prev)}>
            <div class="inline-block text-left ">
              <div className=" flex gap-2 items-center">

                {/* <RiDashboardLine className="text-white text-[28px]" /> */}
                <button type="button" class="inline-flex items-center w-full bg-[#34BFE7] text-[18px] justify-center gap-x-1.5 rounded-md text-white px-3 py-2 xl:font-semibold text-gray-900 border-none" id="menu-button" aria-haspopup="true">
                  <RxDashboard /> <span className="text-[16px] max-sm:hidden">Browse Business By Industry</span> <MdKeyboardArrowDown />
                </button>
              </div>
            </div>
          </div>
          {ismobilemenu}
          <div className={`mobilemenu sm:${ismobilemenu ? "block show" : "hidden"}  lg:block`}>
            <div className="closemenu cursor-pointer" onClick={() => setMobileMenu(!ismobilemenu)}><IoMdCloseCircleOutline /></div>

            <Link to="/" className="text-white 2xl:text-[14px] xl:text-[16px] lg:text-[14px] 2xl:pe-[40px] xlLpe-[40px] lg:pe-[30px]" onClick={() => setMobileMenu(!ismobilemenu)}>Home</Link>
            <Link to="/about" className="text-white 2xl:text-[14px] xl:text-[16px] lg:text-[14px] 2xl:pe-[40px] xlLpe-[40px] lg:pe-[30px]" onClick={() => setMobileMenu(!ismobilemenu)}>About</Link>
            {location?.pathname == "/" ?
              <a href="#event" className="text-white 2xl:text-[14px] xl:text-[16px] lg:text-[14px] 2xl:pe-[40px] xl-pe-[40px] lg:pe-[30px]" onClick={() => setMobileMenu(!ismobilemenu)}>Event</a> : <></>}
            <Link to="/video" className="text-white 2xl:text-[14px] xl:text-[16px] lg:text-[14px] 2xl:pe-[40px] xl-pe-[40px] lg:pe-[30px]" onClick={() => setMobileMenu(!ismobilemenu)}>Videos</Link>
            <Link to="/blogs" className="text-white 2xl:text-[14px] xl:text-[16px] lg:text-[14px] 2xl:pe-[40px] xl-pe-[40px] lg:pe-[30px]" onClick={() => setMobileMenu(!ismobilemenu)}>Blog</Link>
            <Link to="/contact" className="text-white 2xl:text-[14px] xl:text-[16px] lg:text-[14px] 2xl:pe-[40px] xl-pe-[40px] lg:pe-[30px]" onClick={() => setMobileMenu(!ismobilemenu)}>Contact</Link>
            <Link to="/faq" className="text-white 2xl:text-[14px] xl:text-[16px] lg:text-[14px] 2xl:pe-[40px] xl-pe-[40px] lg:pe-[30px]" onClick={() => setMobileMenu(!ismobilemenu)}>F&Q</Link>

            {/* <Link to="/testimonial" className="text-white 2xl:text-[14px] xl:text-[16px] lg:text-[14px] 2xl:pe-[40px] xl-pe-[40px] lg:pe-[30px]">Testimonials</Link> */}
          </div>
          {width <= 991 ?
            <div className="mobilemenudesk cursor-pointer" onClick={() => setMobileMenu(!ismobilemenu)}><HiMenuAlt2 /></div> : <></>}

          <div className="flex items-center gap-[20px] mobile-p max-sm:justify-self-end gap-[12px]" onMouseLeave={() => setShowDropdown(false)}>
            <IoSearch className="text-white text-[24px] cursor-pointer" onClick={() => setIsSearch(true)} />
            {/* <button className="text-white text-[16px]">Login</button>
              <button className="bg-white rounded-[8px] py-[10px] px-[18px]">Register</button> */}
            {token ? (
              <div className="relative flex items-center" onMouseEnter={() => setShowDropdown(true)}  >
                <FontAwesomeIcon
                  icon={faUser}
                  className="text-[#fff]"
                  size="1x"
                />

                {showDropdown && (
                  <UserDropdown handleLogout={handleLogout} />
                )}
              </div>
            ) : (
              <>
                <div
                  className="cursor-pointer"
                  onClick={() => { setShowLogin(!showLogin); setRegister(false) }}
                >
                  <h3 className="text-white text-[16px]">
                    Login
                  </h3>
                  {/* {showDropdown && <UserDropdown handleLogout={handleLogout}/>} */}
                </div>

                <div
                  className="cursor-pointer px-[18px] py-[9px] rounded-[8px] bg-[#ffffff]"
                  onClick={() => { setRegister(!register); setShowLogin(false) }}
                >
                  <h3 className="text-[#13a9d3] font-semibold text-[14px]">
                    Register
                  </h3>
                  {/* {showDropdown && <UserDropdown handleLogout={handleLogout}/>} */}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="relative bg-gray-100">
        {showLogin && !openpopup && <Login onClose={closeLoginForm} />}
        {register && <Register onClose={onCloseRegister} />}
      </div>
      {isSearch && <HomeSearch Isopen={setIsSearch} open={isSearch} isSticky={isSticky} />}
      <>
        {isModalOpen &&
          <Popup isModalOpen={isModalOpen} openpopup={openpopup} closeModal={closeModal} />}
      </>

      {show && <div ref={modalRef}>
        <Category onClose={() => setShow(false)} isSticky={isSticky} />
      </div>}




    </>

  );
}

export default Header;
